import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Box, Typography, Grid, TextField, Button, Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import emailjs from "emailjs-com";

type Option = {
  value: string;
  label: string;
};

const options: Option[] = [
  { value: '0', label: 'ご協業' },
  { value: '1', label: '採用に関して' },
  { value: '2', label: 'フリーランス' },
  { value: '3', label: 'その他' },
];

const Contact = () => {
  const { control, handleSubmit, formState: { errors } } = useForm();
  const [selectedValue, setSelectedValue] = useState<string>('');

  const selectedLabel = options.find(option => option.value === selectedValue)?.label || '';
  const onSubmit = (data: any) => {
    const serviceID = 'service_sgw5afv'; // ここに自分のサービスIDを入力
    const templateID = 'template_2q8r9p8'; // ここに自分のテンプレートIDを入力
    const userID = 'zBeYHVRlXq3Nc_bE5'; // ここに自分のユーザーIDを入力

    // EmailJSの送信処理
    emailjs
      .send(serviceID, templateID, { ...data, area: selectedLabel}, userID)
      .then((response) => {
        alert('送信が完了しました！');
      })
      .catch((err) => {
        alert('送信に失敗しました。再試行してください。');
      });
  };

  return (
    <Box sx={{ 
      margin: '0 auto', 
      marginTop: {xs: '44px', md: '0px' },
      maxWidth: '64%', 
      display: 'flex', 
      justifyContent: "center",
      alignItems: "center",
      flexDirection: 'column', 
      gap: 2, 
      height: '100vh', 
    }}>
      <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '25px', md: '40px'}, fontWeight: 'bold', marginBottom: '0px', fontFamily: "'Noto Serif JP', serif" }}>
        Contact
      </Typography>
      <Typography variant="h5" gutterBottom component="div" sx={{ fontSize: { xs: '13px', md: '30px' }, marginBottom: '0px' }}>
        お問い合わせ
      </Typography>
      <Box id="section2" className="section" sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            {/* 問い合わせ種別 */}
            <Controller
  name="area"
  control={control}
  defaultValue=""
  rules={{ required: '問い合わせ種別は必須です' }}
  render={({ field }) => (
    <FormControl fullWidth error={!!errors.area} sx={{
      margin: { xs: '7px 0',  sm: '8px 0' },
      '& .css-w76bbz-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
        fontSize: { xs: '0.8rem', sm: '1rem' },
        padding: { xs: '6.5px 3px', md: '16px' },
      },
      '& .MuiInputLabel-root': {
        fontSize: { xs: '0.8rem', sm: '1rem' },
      },
      '& .MuiFormHelperText-root': {
        fontSize: { xs: '0.7rem', sm: '0.9rem' },
      },
    }}>
      <InputLabel
        id="area-label"
        sx={{
          top: { xs: '-7px', sm: '0px', md: '0px' }, // 各画面サイズに対応したtopを設定
        }}
      >
        問い合わせ種別
      </InputLabel>
      <Select
        {...field}
        labelId="area-label"
        label="問い合わせ種別"
        value={selectedValue}
        onChange={(e) => {
          field.onChange(e.target.value);  // react-hook-formへの通知
          setSelectedValue(e.target.value);  // ローカル状態の更新
        }}
        sx={{
          fontSize: { xs: '0.8rem', sm: '1rem' }, // Selectのフォントサイズも調整
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )}
/>
            {/* お名前 */}
            <Controller
              name="textBox1"
              control={control}
              rules={{ required: "お名前は必須です" }}
              defaultValue=""
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="お名前"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  error={!!fieldState?.error}
                  sx={{
                    margin: { xs: '7px 0',  sm: '8px 0' },
                    '& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                      padding: { xs: '6.5px 3px', md: '16px' },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: { xs: '0.7rem', sm: '0.9rem' },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      top: { xs: '-7px', md: '0px' },
                    },
                  }}
                />
              )}
            />
            {/* ふりがな */}
            <Controller
              name="textBox2"
              control={control}
              rules={{ required: "ふりがなは必須です" }}
              defaultValue=""
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="ふりがな"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  error={!!fieldState?.error}
                  sx={{
                    margin: { xs: '7px 0',  sm: '8px 0' },
                    '& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                      padding: { xs: '6.5px 3px', md: '16px' },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: { xs: '0.7rem', sm: '0.9rem' },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      top: { xs: '-7px', md: '0px' },
                    },
                  }}
                />
              )}
            />
            {/* 会社名 */}
            <Controller
              name="textBox3"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label="会社名"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  sx={{
                    margin: { xs: '7px 0',  sm: '8px 0' },
                    '& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                      padding: { xs: '6.5px 3px', md: '16px' },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: { xs: '0.7rem', sm: '0.9rem' },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      top: { xs: '-7px', md: '0px' },
                    },
                  }}
                />
              )}
            />
            {/* Eメール */}
            <Controller
              name="textBox4"
              control={control}
              defaultValue=""
              rules={{
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: '有効なEメールアドレスを入力してください',
                },
              }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="Eメール"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  sx={{
                    margin: { xs: '7px 0',  sm: '8px 0' },
                    '& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                      padding: { xs: '6.5px 3px', md: '16px' },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: { xs: '0.7rem', sm: '0.9rem' },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      top: { xs: '-7px', md: '0px' },
                    },
                  }}
                  error={!!fieldState?.error} // エラーがある場合、エラースタイルを適用
                  helperText={fieldState?.error?.message} // エラーメッセージを表示
                />
              )}
            />
            {/* 電話番号 */}
            <Controller
              name="textBox5"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label="電話番号"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  sx={{
                    margin: { xs: '7px 0',  sm: '8px 0' },
                    '& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                      padding: { xs: '6.5px 3px', md: '16px' },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: { xs: '0.7rem', sm: '0.9rem' },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      top: { xs: '-7px', md: '0px' },
                    },
                  }}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    field.onChange(value);
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            {/* お問い合わせ内容 */}
            <Controller
              name="textArea"
              control={control}
              defaultValue=""
              rules={{
                required: 'このフィールドは必須です',
                maxLength: {
                  value: 500,
                  message: '500文字以内で入力してください',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  multiline
                  fullWidth
                  rows={4}
                  label="お問い合わせ内容"
                  variant="outlined"
                  helperText={`${field.value?.length}/500`}
                  sx={{
                    margin: { xs: '7px 0',  sm: '8px 0' },
                    '& .css-zsp0bh-MuiInputBase-root-MuiOutlinedInput-root': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                      padding: { xs: '0px', md: '16px' },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: { xs: '0.7rem', sm: '0.9rem' },
                    },
                  }}
                />
              )}
            />

            <Box sx={{ marginTop: { xs: 1, sm: 1 }, display: 'flex' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit(onSubmit)}
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                }}
              >
                送信
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
export default Contact;
